import { apiWrapper } from 'ccs-ui-components';
import { call, fork, put, takeLatest } from 'redux-saga/effects';
import { IService } from '../../../models/index';
import { getServiceType } from '../../actions/actionType/services/ServiceActionTypes';

import {
  clearService,
  getServiceFailure,
  getServiceStarted,
  getServiceSuccess
} from '../../actions/sagaActions/services/ServiceNameSagaAction';

import { headersInstance } from '../../../../common/utils/HeaderUtils';
import { serviceSearchResponseSchema } from '../../../utilities/sources/RegistriesSchemaDefintion';
import {
  GetServiceFailurePayload,
  GetServiceRequest
} from '../../actions/types/services/GetAllServiceType';

/**
 * Call Gets service by Name API
 * @param serviceName : string
 * @returns api response
 */
export async function callGetServiceApi(serviceName: string, version: string) {
  const resp = await apiWrapper.get<IService[], { errorMessage: string }>(
    `${process.env.REACT_APP_API_CONTROL_PLANE_SERVICE_BASE_URL}/services/${serviceName}/version/${version}`,
    headersInstance()
  );

  const apiResponse = serviceSearchResponseSchema.validate(resp.responseBody, {
    abortEarly: true
  });

  if (resp.error || !apiResponse.value) {
    return {
      errorMessage: resp.errorBody?.errorMessage,
      isError: resp.isError,
      statusCode: resp.statusCode
    };
  }
  const serviceRecords = resp.responseBody;
  return {
    serviceRecords,
    isError: resp.isError,
    statusCode: resp.statusCode
  };
}

/**
 * Saga to get service by serviceName
 * @param serviceName:string
 */
export function* getServiceByServiceName({ serviceName, version }: GetServiceRequest) {
  yield put(clearService());
  yield put(getServiceStarted());
  try {
    const { serviceRecords, errorMessage } = yield call(callGetServiceApi, serviceName, version);
    if (serviceRecords) {
      yield put(getServiceSuccess(serviceRecords));
    } else {
      throw new Error(errorMessage);
    }
  } catch (error) {
    const obj: GetServiceFailurePayload = {
      error: String(error)
    };
    yield put(getServiceFailure(obj));
  }
}

/**
 * Saga Effect to consider latest request
 */
export function* fetchServiceDetailsSaga() {
  yield takeLatest(getServiceType.FETCH_SERVICE_REQUEST, getServiceByServiceName);
}

export const getServiceDetailsSaga = [fork(fetchServiceDetailsSaga)];
